import { FC, ReactNode } from 'react';
import { PptOchPptxFilResponse } from '../../types/media';
import { ContentResponse } from '../../types/shared';

interface IPptOchPptxFilFil {
  contentResponse: ContentResponse;
}

const PptOchPptxFil: FC<IPptOchPptxFilFil> = ({ contentResponse }): ReactNode => {
  const contentResponsePpt = contentResponse.content as PptOchPptxFilResponse;

  return <a href={contentResponsePpt.relativeSourceUrl} download>{contentResponse.name}</a>;
};

export default PptOchPptxFil;
